import routes from './routes';
import {ModuleConfig} from "@/core/module";

const CustomerOnboardingModule: ModuleConfig = {
  name: 'customer-onboarding',
  displayName: 'Customer Onboarding',
  description: 'Customer onboarding and registration module',
  version: '1.0.0',
  routes,
  permissions: [], // Will be populated based on requirements
  dependencies: ['customer-category', 'location', 'document-type'],
};

export default CustomerOnboardingModule;
